var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 443 409"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heart_svg__a",
    x1: 287.208,
    y1: -7.13,
    x2: 128.203,
    y2: 315.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#ff3871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#ff68c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#ff0032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#900032"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.976 2.992c37.911 0 74.08 17.867 98.047 45.755 23.967-27.888 60.135-45.755 98.046-45.755 67.107 0 119.831 52.728 119.831 119.835 0 82.359-74.08 149.466-186.506 251.435l-31.375 28.76-31.375-28.76C78.221 272.293 4.142 205.186 4.142 122.827 4.142 55.72 56.869 2.992 123.976 2.992Z",
    fill: "url(#heart_svg__a)"
  })));
};
export default SvgHeart;